import styles from "./SubmitButton.module.css"
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { getColorVariantClass } from "../../../utils/classNames";

/**
* Props for the SubmitButton component.
*/
interface SubmitButtonTypes {
    text: string, // Button label
    onClick?: (e: any)=> void, // Click event handler
    className?:string, // Optional additional class
    colorVariant?: string, // Color variant
    disabled?: boolean // Disable the button
    left?: boolean // Whether to show icon on the left
}
/**
* A button for submiting.
*
* @param props SubmitButton props
* @param {string} props.colorVariant - Color variant
* @param {string} props.text - Button label
* @param {boolean} props.disabled - Disable the button
* @param {string} props.className - Optional additional class
* @param {() => void} props.onClick - Function to call on click.
* @param {() => void} props.left - Whether to show icon on the left
* @returns TSX.Element
*/
const SubmitButton = ({ text, disabled = false, onClick, colorVariant = "secondary" , className, left = false} : SubmitButtonTypes) => {
    const buttonClassName = getColorVariantClass(styles, "SubmitButton", {
        colorVariant,
        disabled,
        className,
    });

    return(
        <>
            <button onClick={onClick} className={buttonClassName} disabled={disabled}>
                {left === true && <ChevronLeft/>}
                <span>{text}</span>
                {left === false && <ChevronRight/>}
            </button>
        </>
    )
}
export default SubmitButton;